module.exports = "{{#each columns}}\r\n    <div class=\"grid-header-column\">\r\n        <div class=\"grid-header-column-content-view\"></div>\r\n        {{#unless @last}}\r\n            <div class=\"grid-header-dragger\"></div>\r\n        {{/unless}}\r\n    </div>\r\n{{/each}}";


//////////////////
// WEBPACK FOOTER
// ../src/list/templates/gridheader.hbs
// module id = 708
// module chunks = 0